import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// Self-hosted fonts (bundled into the app) so the UI renders correctly offline
// and inside the native shell without a round-trip to the Google Fonts CDN.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './index.css';
import { bootstrapNative } from './lib/native/bootstrap';
import { reloadForChunkError } from './lib/chunkReload';

// Stale-deploy recovery (first line of defense). Vite fires `vite:preloadError`
// on the window when a dynamically imported chunk fails to load — almost always
// because a new build was deployed while this tab was open. Reload once to pick
// up the current chunk hashes; if we just reloaded, let it fall through to the
// error boundary so the user gets a manual option instead of a reload loop.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForChunkError()) event.preventDefault();
});

// Kick off native platform setup (status bar, splash, connectivity). No-op on
// the web; we don't await so React can render immediately.
void bootstrapNative();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
